import { config, handleResponse } from '../../_helpers';

export const customerRequestServices = {
    fTSCompanyName,
    loadRequested,
    getRequestedId,
    createRequested,
    updateRequestedId,
    updateToArchive,
    updateStatus,
    deleteRequest,
}
function fTSCompanyName(company) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(company),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/RequestedCustomers/fTSCompanyName`, requestOptions).then(handleResponse);
}
function loadRequested(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/RequestedCustomers/loadRequested`, requestOptions).then(handleResponse);
}
function getRequestedId(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/RequestedCustomers/getRequestedId`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/RequestedCustomers/getRequestedIdV1`, requestOptions).then(handleResponse);
}
function createRequested(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/RequestedCustomers/createRequested`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/RequestedCustomers/createRequestedWithRev`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/RequestedCustomers/createRequestedWithRev2`, requestOptions).then(handleResponse);
}
function updateRequestedId(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/RequestedCustomers/updateRequestedId/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/RequestedCustomers/updateRequestedIdWithRev/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/RequestedCustomers/updateRequestedIdWithRev1/${id}`, requestOptions).then(handleResponse);
}
function updateToArchive(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/RequestedCustomers/updateToArchive`, requestOptions).then(handleResponse);
}
function updateStatus(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/RequestedCustomers/updateStatus`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/RequestedCustomers/updateStatusV1`, requestOptions).then(handleResponse);
}
function deleteRequest(payload) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/RequestedCustomers/deleteRequest`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/RequestedCustomers/deleteRequestV1`, requestOptions).then(handleResponse);
}